import React from "react";
import { useNavigate } from "react-router-dom";
import { Map as MapIcon, LayoutGrid, Sparkles } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { setGuestHomeMode } from "../../lib/homeMode";
import api from "../../lib/api";

// Interruttore rapido Mappa Viva ⇄ Home Smart. Il cambio è immediato e viene ricordato
// (profilo per i clienti loggati, localStorage per gli ospiti).
export function HomeModeToggle({ current }) {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();

  const go = async (mode) => {
    if (mode === current) return;
    if (user?.role === "customer") {
      try {
        const { data } = await api.put("/auth/profile", { home_mode: mode });
        setUser(data);
      } catch { /* fallback silenzioso */ }
    } else {
      setGuestHomeMode(mode);
    }
    navigate(mode === "ai" ? "/ai" : mode === "smart" ? "/home" : "/esplora");
  };

  const seg = (mode, Icon, label) => {
    const active = current === mode;
    return (
      <button
        data-testid={`toggle-home-${mode}`}
        onClick={() => go(mode)}
        aria-pressed={active}
        className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[#00E676] ${
          active ? "bg-[#00E676] text-black shadow-sm" : "bg-transparent text-white/50 hover:text-white"
        }`}
      >
        <Icon className="h-4 w-4" /> <span className="hidden sm:inline">{label}</span>
      </button>
    );
  };

  return (
    <div data-testid="toggle-home-mode" className="inline-flex items-center rounded-full bg-white/5 border border-white/10 p-1">
      {seg("ai", Sparkles, "AI")}
      {seg("mappa", MapIcon, "Mappa")}
      {seg("smart", LayoutGrid, "Smart")}
    </div>
  );
}
